import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AuthHandler from "../../services/common/auth-handler";

const authHandler = AuthHandler();
const NotFoundPage = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(authHandler.getLanguage());
    }, [i18n])

    return (
        <div className="height-100 d-flex flex-column justify-content-center align-items-center">
            <img
                alt="page not found"
                src={`${process.env.PUBLIC_URL}/images/not-found.svg`} />
            <h1 className="c-dark-blue fw-semi-bold">404 {t("page_not_found")}</h1>
            <div className="text-center w-75">
                <span className="c-dark-blue">
                   {t("page_not_found_content")}
                </span>
            </div>
        </div>);
}

export default NotFoundPage;